import { IInventoryStatisticsSummary } from "domain/Inventory/Models/IInventoryStatisticsSummary";
import SBInventoryInfoModal from "modules/Inventory/components/SBInventoryInfoModal";
import { useNotificationsRequester } from "modules/Notifications/hooks/useNotificationsRequester";
import { createContext, ReactNode, useEffect, useState } from "react";
import { useLocation } from "react-router";

export const SBGlobalInventoryInfoProvider = (
	props: SBGlobalInventoryInfoProviderProps
) => {
	const { pathname } = useLocation();
	const { children } = props;
	const [statisticsID, setStatisticsID] = useState<number | undefined>(
		undefined
	);
	const [clientIDParams, setClientIDParams] = useState<{ productClientID: string; storeClientID: string } | undefined>(undefined);
	const [isOpen, setIsOpen] = useState(false);
	const [loading, setLoading] = useState(true);
	const [statistics, setStatistics] = useState(
		{} as IInventoryStatisticsSummary
	);

	const notificationsRequester = useNotificationsRequester();

	useEffect(() => {
		if (statisticsID) {
			setLoading(true);
			setIsOpen(true);
			notificationsRequester.statistics(statisticsID).then((data) => {
				setStatistics(data.data);
				setLoading(false);
			});
		}
	}, [statisticsID]);

	useEffect(() => {
		if (clientIDParams) {
			setLoading(true);
			setIsOpen(true);
			notificationsRequester.statisticsByClientID(clientIDParams.productClientID, clientIDParams.storeClientID).then((data) => {
				setStatistics(data.data);
				setLoading(false);
			});
		}
	}, [clientIDParams]);

	useEffect(() => {
		closeModal();
	}, [pathname])

	const closeModal = () => {
		setIsOpen(false);
		setStatisticsID(undefined);
		setClientIDParams(undefined);
	}

	return (
		<InventoryInfoContext.Provider
			value={{
				isOpen,
				openMenu: (id: number) => setStatisticsID(id),
				openMenuByClientID: (productClientID: string, storeClientID: string) => setClientIDParams({ productClientID, storeClientID }),
			}}
		>
			{children}
			<SBInventoryInfoModal
				isMenuOpen={isOpen}
				loading={loading}
				statistics={statistics}
				closeMenu={closeModal}
			/>
		</InventoryInfoContext.Provider>
	);
};

const InventoryInfoContext = createContext(
	{} as {
		isOpen: boolean;
		openMenu: (id: number) => void;
		openMenuByClientID: (productClientID: string, storeClientID: string) => void;
	}
);

export const useGlobalInventoryContext = InventoryInfoContext;

interface SBGlobalInventoryInfoProviderProps {
	children: ReactNode;
}
